import NodeService from '@/services/node.service'
import Utils from '@/utils'

const state = {
    page: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    ancestors: []
}

const getters = {}

const actions = {
    create: async ({ commit }, args) => {
        try {
            await NodeService.create(args)
            commit('createNodeSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    read: async ({ commit }, args) => {
        if (!args) args = {}
        try {
            if (args.item) {
                let page = await NodeService.read(args.item.id)
                page.data.results.forEach(e => e.checked = !!args.item.checked)
                if (typeof args.item.children == Array) {
                    args.item.children.concat(page.data.results)
                } else {
                    args.item.children = page.data.results
                }
            } else {
                if (!args.page) args.page = 1
                if (state.page.index == args.page) return true
                let page = await NodeService.read(args)
                commit('readNodesSuccess', page.data, args.page)
            }
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readAncestors: async ({ commit }, args) => {
        if (!args || !args.id) return 400
        try {
            let ancestors = await NodeService.readAncestors(args.id)
            commit('readAncestorsSuccess', ancestors.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    update: async ({ commit }, args) => {
        try {
            await NodeService.update(args.id, args)
            commit('updateNodeSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    delete: async ({ commit }, { id }) => {
        try {
            await NodeService.delete(id)
            commit('deleteNodeSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    createNodeSuccess(state) {
        // success
    },

    readNodesSuccess(state, page, page_index) {
        Utils.datetimeConverter(page.results)
        state.page = page
        state.page.index = page_index
    },
    readAncestorsSuccess(state, ancestors) {
        state.ancestors = ancestors
    },

    updateNodeSuccess(state) {
        // success
    },

    deleteNodeSuccess(state) {
        // success
    }
}

const nodes = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default nodes
export { nodes }
